import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcceptableUsePolicyComponent } from '../../core/app-footer/footer-pages/acceptable-use-policy/acceptable-use-policy.component';
import { CookiePolicyComponent } from '../../core/app-footer/footer-pages/cookie-policy/cookie-policy.component';
import { DisclaimerComponent } from '../../core/app-footer/footer-pages/disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from '../../core/app-footer/footer-pages/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from '../../core/app-footer/footer-pages/terms-of-use/terms-of-use.component';
import { CustomerManagementPageComponent } from '../../customer-management-page/customer-management-page.component';
import { DeviceManagementPageComponent } from '../../device-management-page/device-management-page.component';
import { HomeComponent } from '../home/home.component';
import { CustomerAddPageComponent } from 'src/app/customer-add-page/customer-add-page.component';
import { CustomerEditPageComponent } from 'src/app/customer-edit-page/customer-edit-page.component';
import { unsavedChangesGuard } from 'src/app/guards/unsaved-changes.guard';
import { CustomerUsageComponent } from 'src/app/customer-usage/customer-usage.component';
import { MetricsDashboardComponent } from 'src/app/metrics-dashboard/metrics-dashboard.component';
import { UserAuditLogPageComponent } from 'src/app/user-audit-log-page/user-audit-log-page.component';
import { authGuard } from 'src/app/guards/auth-guard/auth.guard';
import { synxGuard } from 'src/app/guards/synx-guard/synx.guard';
import { IoTToolPageComponent } from '../../iot-tool-page/iot-tool-page.component';

const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'device-management',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'customer-management/usage',
        component: CustomerUsageComponent
      },
      {
        path: 'customer-management/metrics',
        component: MetricsDashboardComponent,
        canActivate: [authGuard, synxGuard]
      },
      {
        path: 'customer-management/list',
        component: CustomerManagementPageComponent
      },
      {
        path: 'customer-management/list/add',
        component: CustomerAddPageComponent
      },
      {
        path: 'customer-management/list/edit/:id',
        component: CustomerEditPageComponent,
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'device-management',
        component: DeviceManagementPageComponent,
      },
      {
        path: 'iot-tool',
        component: IoTToolPageComponent,
        canActivate: [authGuard, synxGuard],
      },
      {
        path: 'user-audit-log',
        component: UserAuditLogPageComponent,
        canActivate: [authGuard],
      },

      /**
       * Footer-Pages routes
       */

      {
        path: 'acceptable-use-policy',
        component: AcceptableUsePolicyComponent,
      },
      {
        path: 'cookie-policy',
        component: CookiePolicyComponent,
      },
      {
        path: 'disclaimer',
        component: DisclaimerComponent,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'terms-of-use',
        component: TermsOfUseComponent,
      },
    ],
  },
];

// export const HomeRoutingModule = RouterModule.forRoot(AppRoutes, {
//   scrollPositionRestoration: 'enabled',
// });

@NgModule({
  imports: [RouterModule.forChild(AppRoutes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
